import { IconButton, Tooltip } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import qs from 'query-string'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { QueryParamAllShops } from './HaynesUtils'

interface IProps {
  row: { License: { UUID: string } }
  companyUUID: string
  allShop: boolean
}

export const EditButton = ({ row, companyUUID, allShop }: IProps) => {
  const { t } = useTranslation()

  const link = `/companies/${companyUUID}/licenses/edit/${row.License.UUID}?${qs.stringify({ [QueryParamAllShops.key]: allShop })}`
  return (
    <Tooltip title={`${t('global.open')}`} placement='top' arrow>
      <IconButton component={Link} to={link}>
        <EditIcon />
      </IconButton>
    </Tooltip>
  )
}
export default EditButton
